import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DealApplicationRequirementUtility {
    getApplicationProperties(application) {
    const requiredQuestions = _(application)
      .filter(this.needsToBeAnswered(application))
      .value();
    const answered = _(requiredQuestions)
      .filter(this.isAnswered)
      .value()
      .length;
    const unansweredQuestions = _(requiredQuestions)
      .omitBy(this.isAnswered)
      .map(question => question.shortName || question.name)
      .value();
    const total = requiredQuestions.length;
    const missingFieldNames = unansweredQuestions.length > 0 ?
      'Missing:  ' + _(unansweredQuestions).join(',  ') :
      'All answered!';
    let percentComplete: number;
    if (answered === total) {
      percentComplete = 100;
    } else {
      percentComplete = Math.round((answered / total) * 100);
    }
    return {
      application,
      fulfilledCount: answered,
      requiredCount: total,
      percentComplete,
      missingFieldNames
    };
  }

  needsToBeAnswered(questionList) {
    return (question) => {
      if (question.type === 'document') {
        return false;
      }
      if (question.mustAllowNull === true) {
        return false;
      }
      if (question.dependsOn) {
        return this.dependencyShouldShow(question, questionList);
      }
      return true;
    };
  }

  isAnswered(question) {
    return question.value !== null && question.value !== undefined && question.value !== '';
  }

  dependencyShouldShow(question, questionList) {
    const dependencyQuestion = _(questionList).find({alias: question.dependsOn});
    if (question.dependsOn && question.alias  && !dependencyQuestion) {
      console.error(`Question '${question.dependsOn}' is depended on by '${question.alias}', but it was not included in the questionList`);
      return true;
    }
    if (!question.dependsExpression) {
      return true;
    }
    if (!dependencyQuestion) {
      return true;
    }
    const regex = new RegExp(question.dependsExpression);
    if (regex && !regex.test(dependencyQuestion.value)) {
      return false;
    }
    return this.dependencyShouldShow(dependencyQuestion, questionList);
  }

  annotateProductApplication(appQuestions, answeredQuestions) {
    const indexed = _(answeredQuestions).keyBy('alias').value();
    const annotatedQuestions = _(appQuestions)
      .map(appQuestion => _.assign({ value: null }, appQuestion, _(indexed).get(appQuestion.alias, {})))
      .value();
      return this.getApplicationProperties(annotatedQuestions);
  }
}
